import { useMemo, useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { StylishNewSearchBar } from 'components/DesignSystems/New/StylishNewSearchBar';
import { useCustomEvents } from 'hooks/customEvents/useCustomEvents';
import { EventListItem } from './EventListItem';
import NewEventDialog from './NewEventDialog';

const Events: React.FC = () => {
  const { data: events = [], isLoading } = useCustomEvents();
  const [searchTerm, setSearchTerm] = useState('');
  const [showNewEventDialog, setShowNewEventDialog] = useState(false);

  const filteredEvents = useMemo(
    () =>
      events.filter((event) =>
        event.name.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    [events, searchTerm]
  );

  return (
    <div className="d-flex flex-column gap-3 px-2 pt-2 pb-5">
      <div className="bg-bgdark rounded border border-neutral-500 p-3">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
          <div className="d-flex align-items-baseline flex-shrink-0 gap-2">
            <span>Events</span>
            <span>({filteredEvents.length})</span>
          </div>
          <div className="d-flex flex-column flex-lg-row align-items-lg-center w-lg-auto w-100 gap-2">
            <StylishNewSearchBar
              placeholder="Search events..."
              value={searchTerm}
              onChangeSearchTerm={(value: string) =>
                setSearchTerm(value.trim())
              }
            />
            <Button onClick={() => setShowNewEventDialog(true)}>
              <Plus data-icon="inline-start" />
              Create Event
            </Button>
          </div>
        </div>
      </div>

      {!isLoading && filteredEvents.length === 0 ? (
        <div className="p-3 text-center">No events found.</div>
      ) : (
        <div className="d-grid gap-2">
          {filteredEvents.map((event, index) => (
            <EventListItem
              key={event.id}
              event={event}
              defaultCollapsed={index !== 0}
            />
          ))}
        </div>
      )}

      {showNewEventDialog && (
        <NewEventDialog onClose={() => setShowNewEventDialog(false)} />
      )}
    </div>
  );
};

export default Events;
